<template>
	<div
    style="position: relative;"
  >
    <div
      style="display: flex;align-content: center;align-items: center;height: 80px;background:#ECEFF1;"
      :class="{'closed': xcase && !xcase.active}"
    >
      <v-btn
        icon
        @click="$emit('back')"
      >
        <v-icon>
          mdi-chevron-left
        </v-icon>
      </v-btn>
      <div
        style="flex-grow: 1;display: column;"
      >
        <div
          v-if="xcase && xcase.case_type"
          style="font-size:18px;"
        >
          <b>{{ xcase.case_type.name }}</b>
        </div>
        <div>
          <span
            v-if="xcase && xcase.case_number"
          >
            <span
              style="font-weight: bold;margin-right: 10px;"
            >
              {{ xcase.case_number }}
            </span>
          </span>
          <span
            v-if="xcase && xcase.case_title"
          >
            {{ xcase.case_title }}
          </span>
          <v-fade-transition>
            <v-chip
              v-if="!xcase.active"
              small
              color="#F44336"
              dark
              style="margin-right:10px;"
            >
              Closed
            </v-chip>
          </v-fade-transition>
        </div>
      </div>
      <div
        v-if="!loading"
      >
        <v-btn
          v-if="checkPermission('cases', PERMISSIONS.CAN_EDIT)"
          color="dark"
          style="margin:auto;margin-right: 10px;"
          flat
          @click="editCase = true"
        >
          Edit
        </v-btn>
        <v-btn
          v-if="checkPermission('userform', PERMISSIONS.CAN_CREATE)"
          color="primary"
          style="margin:auto;margin-right: 25px;"
          flat
          @click="addForm = true"
        >
          Add Form
        </v-btn>
      </div>
    </div>
    <v-expand-transition>
      <v-progress-linear
        v-if="loading"
        indeterminate
        style="padding:0;margin:0;"
      />
    </v-expand-transition>
    <div
      style="padding:10px;"
    >
      <v-card-text>
        <v-layout>
          <v-flex
            xs12
            sm6
            md3
          >
          <b>Form</b>
          </v-flex>
          <v-flex
            xs12
            sm6
            md3
          >
          <b>Status</b>
          </v-flex>
          <v-flex
            xs12
            sm6
            md3
          >
          <b>Date Issued</b>
          </v-flex>
          <v-flex
            xs12
            sm6
            md3
          >
          <b>Last Updated</b>
          </v-flex>
        </v-layout>
      </v-card-text>
      <div
        v-if="xcase"
      >
        <div
          v-if="xcase.userforms.length > 0"
        >
          <v-card
            v-for="uf in xcase.userforms"
            :key="uf.id"
            style="margin-bottom: 15px;"
          >
            <UserFormRow
              :userform="uf"
            />
          </v-card>
        </div>
        <div
          v-else
          style="text-align:center;padding: 15%;font-size: 16px;"
        >
          <v-icon size="64">mdi-briefcase-outline</v-icon><br />
          <b>This case is empty</b><br />
          Add a form to get started
        </div>
      </div>
    </div>
    <v-dialog
      v-model="addForm"
      persistent
      width="800"
    >
      <v-card
        style="position:relative;height: 455px;overflow:hidden;"
      >
        <v-fade-transition>
          <form-template-select
            v-if="addForm && !confirmTemplate"
            :caseType="xcase.case_type.id"
            @select="addFormToCase"
            @confirm="checkConfirmTemplate"
            @cancel="addForm = false"
          />
        </v-fade-transition>
        <v-fade-transition>
          <div
            v-if="addForm && confirmTemplate"
          >
            <v-card-text>
              <FormTemplatePreview
                :id="addTemplate.template_id"
              />
              <v-text-field
                v-model="addTemplate.party_name"
                persistent-hint
                autofocus
                solo
                hint="Party Name - The Party's Name that this Form will be assigned to; ex. Injured Party"
              />
              <v-text-field
                v-model="addTemplate.form_number"
                persistent-hint
                solo
                hint="Form Number - An identifier for this Form related to the Party"
              />
              <br />
              <v-combobox
                v-model="addTemplate.tags"
                :items="tagResults"
                :search-input.sync="tagSearch"
                multiple
                persistent-hint
                hint="Form Tags"
                item-text="tag"
                item-value="tag"
                :return-object="false"
                solo
                small-chips
                hide-selected
                auto-select-first
                @input="tagSearch = ''"
              />
            </v-card-text>
          </div>
        </v-fade-transition>
        <v-card-actions
          style="position: absolute;bottom:0;left:0;right:0;"
        >
            <v-spacer />
            <v-btn
                flat
                @click="confirmTemplate ? confirmTemplate=false : addForm = false;addTemplate=null"
            >
              {{ confirmTemplate ? 'Back' : 'Cancel' }}
            </v-btn>
            <v-btn
                color="primary"
                :disabled="!addTemplate"
                @click="confirmTemplate ? postTemplateToCase() : confirmTemplate = true"
            >
              {{ confirmTemplate ? 'Add Form' : 'Next' }}
            </v-btn>
        </v-card-actions>
      </v-card>
    </v-dialog>
    <v-dialog
      v-model="editCase"
      persistent
      width="400"
    >
      <v-fade-transition>
        <v-card
          v-if="editCase"
        >
          <CaseSettings
            :xcase="xcase"
            @cancel="editCase = false"
            @save="editCase = false;fetchCase()"
          />
        </v-card>
      </v-fade-transition>
    </v-dialog>
	</div>
</template>

<script>
import api from '@/api'
import FormTemplateSelect from '../formtemplate/FormTemplateSelect.vue'
import FormTemplatePreview from '../formtemplate/FormTemplatePreview.vue'
import UserFormRow from '../userform/UserFormRow.vue'
import CaseSettings from '../cases/CaseSettings.vue'

export default {
    name: "CaseView",
    components: {
      FormTemplateSelect,
      FormTemplatePreview,
      UserFormRow,
      CaseSettings
    },
    props: ['selected'],
    data () {
      return {
        xcase: null,
        addForm: false,
        addTemplate: null,
        tagSearch: null,
        tagResults: [],
        confirmTemplate: false,
        loading: false,
        editCase: false,
      }
    },
    watch: {
      tagSearch () {
        if (this.tagSearch) {
          this.fetchTags()
        }
      }
    },
    methods: {
      fetchCase () {
        this.loading = true
        api.cases.cases.get(this.selected)
          .then(xcase => {
            this.xcase = xcase
          })
          .finally(() => {
            this.loading = false
          })
      },
      checkConfirmTemplate () {
        if (this.addTemplate && this.addTemplate.template_id)
          this.confirmTemplate = true
      },
      postTemplateToCase () {
        api.cases.cases.addUserForm(this.xcase, ...Object.values(this.addTemplate))
          .then(xcase => {
            this.addTemplate = null
            this.confirmTemplate = false
            this.addForm = false
            this.fetchCase()
          })
      },
      fetchTags () {
        api.userform.contactTags.get(this.tagSearch)
          .then(tagResults => {
            this.tagResults = tagResults
          })
      },
      addFormToCase (template_id) {
        if (!template_id)
          return
        this.addTemplate = {
          template_id: template_id,
          form_number: null,
          party_name: null,
          tags: []
        }
      }
    },
    created () {
      if (this.selected)
        this.fetchCase()
    }
}
</script>

<style scoped>

.closed {
  background: #FFEBEE !important;
}

</style>